import InstallationConstruction37Header from "./Header";
import "./index.css";
import { useState, useEffect } from "react";
import MaterialUsage37_1 from "./MaterialUsage37_1";
import SurplusResources37_2 from "./SurplusResources37_2";
import ByProducts37_3 from "./ByProducts37_3";
import Losses37_4 from "./Losses37_4";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../components/TableLoadingWrapper";

const ProdInstallationConstruction37Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const [totalProdItem, setTotalProdItem] = useState([]);

  return (
    <div className="prod-installation-construction-37-container" id="prod-installation-construction-37-id">
      <InstallationConstruction37Header
        productId={productId}
        show={show}
        totalProdItem={totalProdItem}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <MaterialUsage37_1 productId={productId} />
          <SurplusResources37_2 productId={productId} />
          <ByProducts37_3 productId={productId} />
          <Losses37_4 productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdInstallationConstruction37Components;

